import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

import { Spinner } from 'react-bootstrap';

const StatusModal = ({ show, onHide, type, message, onConfirm, customContent }) => {
  const isSuccess = type === 'success';
  let isConfirm = type === 'confirm' || type === 'upgrade_limit';
  const isLoading = type === 'loading';

  if (customContent) {
    return (
      <Modal show={show} onHide={onHide} centered className="status-modal custom-content-modal">
        <Modal.Body className="p-0">
          {customContent}
        </Modal.Body>
      </Modal>
    );
  }

  let icon;
  let title;
  let confirmBtnText;
  let cancelBtnText;
  let confirmBtnVariant;

  if (isLoading) {
    icon = <Spinner animation="border" variant="success" style={{ width: '60px', height: '60px' }} />;
    title = 'Please Wait...';
  } else if (isSuccess) {
    icon = <FaCheckCircle className="animate-pop-in" size={60} color="#28a745" />;
    title = 'Success!';
    confirmBtnText = 'Continue';
    confirmBtnVariant = 'success';
  } else if (isConfirm) {
    icon = <FaCheckCircle size={60} color="#ffc107" />;
    title = 'Confirm Action';
    confirmBtnText = 'Yes, Proceed';
    cancelBtnText = 'No, Cancel';
    confirmBtnVariant = 'warning';
  } else if (type === 'upgrade_limit') {
    icon = <FaCheckCircle size={60} color="#ffc107" />;
    title = 'Upgrade Required';
    confirmBtnText = 'Upgrade Now';
    cancelBtnText = 'Maybe Later';
    confirmBtnVariant = 'primary';
    isConfirm = true;
  } else if (type === 'warning') {
    icon = <FaExclamationTriangle className="animate-pop-in" size={60} color="#fd7e14" />;
    title = 'Warning';
    confirmBtnText = 'Okay';
    confirmBtnVariant = 'warning';
  } else if (type === 'info') {
    icon = <FaInfoCircle className="animate-pop-in" size={60} color="#17a2b8" />;
    title = 'Notice';
    confirmBtnText = 'Okay';
    confirmBtnVariant = 'info';
  } else {
    icon = <FaTimesCircle className="animate-pop-in" size={60} color="#dc3545" />;
    title = 'Error!';
    confirmBtnText = 'Close';
    confirmBtnVariant = 'danger';
  }

  return (
    <Modal show={show} onHide={isLoading ? null : onHide} centered className="status-modal" backdrop={isLoading ? 'static' : true} keyboard={!isLoading}>
      <Modal.Body className="text-center p-5">
        <style>
          {`
            @keyframes PopIn {
              0% { transform: scale(0); opacity: 0; }
              80% { transform: scale(1.1); opacity: 1; }
              100% { transform: scale(1); opacity: 1; }
            }
            .animate-pop-in {
              animation: PopIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
            }
          `}
        </style>
        <div className="mb-4 d-flex justify-content-center align-items-center">
          {icon}
        </div>
        <h4 className="mb-3" style={{ color: isSuccess ? '#28a745' : isConfirm ? '#ffc107' : isLoading ? '#28a745' : type === 'warning' ? '#fd7e14' : type === 'info' ? '#17a2b8' : '#dc3545' }}>
          {title}
        </h4>
        <div className="mb-4 text-center" style={{ fontSize: '1.1rem', color: '#555', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>
          {message}
        </div>
        {!isLoading && (
          <div className="d-flex justify-content-center gap-3">
            {isConfirm && (
              <Button 
                variant="secondary" 
                onClick={onHide}
                style={{ minWidth: '120px' }}
              >
                {cancelBtnText}
              </Button>
            )}
            <Button 
              variant={confirmBtnVariant} 
              onClick={onConfirm || onHide}
              style={{ minWidth: '120px' }}
            >
              {confirmBtnText}
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default StatusModal;
